module.exports = __webpack_public_path__ + "img/编组 15@2x.36cbd738.png";